import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// children ke saath bhi chalta hai, aur <Route element={<ProtectedRoute />}> (Outlet) ke saath bhi
const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const {
    user,
    loading,
    isStoreVerified,
    isStorePending,
    isStoreRejected,
  } = useAuth();
  const location = useLocation();

  const content = children ?? <Outlet />;

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    if (location.pathname.startsWith('/seller')) {
      return <Navigate to="/seller/login" state={{ from: location }} replace />;
    }
    if (location.pathname.startsWith('/admin')) {
      return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // ==================== SELLER VALIDATION CHECKS ====================
  if (user.role === 'seller' && isStorePending()) {
    return <Navigate to="/seller/pending" replace />;
  }
  if (user.role === 'seller' && isStoreRejected()) {
    return <Navigate to="/seller/rejected" replace />;
  }
  if (user.role === 'seller' && !isStoreVerified()) {
    return <Navigate to="/seller/pending" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    if (user.role === 'superadmin') {
      return content;
    }
    return <Navigate to="/unauthorized" replace />;
  }

  return content;
};

export default ProtectedRoute;
